import { createSlice } from "@reduxjs/toolkit";

const sessionSlice = createSlice({
  name: "session",
  initialState: {
    config: null,
    timeout: null,
    tenantSettings: null,
    avatar: null,
    networkError: false,
    pageError: false,
    supportedLanguages: [], // The array of available languages
  },
  reducers: {
    setAuthConfig(state, action) {
      state.config = action.payload;
      state.timeout = action.payload.inactiveSessionExpiryInSeconds;
    },
    setTenantSettings(state, action) {
      state.tenantSettings = action.payload;
    },
    setNetworkError(state, action) {
      state.networkError = action.payload;
    },
    setPageError(state, action) {
      state.pageError = action.payload;
    },
    setAvatar(state, action) {
      state.avatar = action.payload;
    },
    setSupportedLanguages(state, action) {
      state.supportedLanguages = action.payload;
    },
    //we use this inside base reducer to clear the redux state
    clearState() {},
  },
});

export const { setAuthConfig, setTenantSettings, setNetworkError, setPageError, setAvatar, setSupportedLanguages, clearState } =
  sessionSlice.actions;
export default sessionSlice.reducer;
